import React from 'react'
import {inject, observer} from 'mobx-react'
import styles from './style.css'
import Avatar from '../Avatar'

const CurrentUser = inject('store')(observer(function CurrentUser({store}) {
  const currentUser = store.currentUser
  const thumb = store.currentUserThumb
  return currentUser && thumb && <div className={styles.currentUser}>
    <Avatar avatar={thumb} size={45} borderWidth={1} />
    <span className={styles.name}>
      <p>{currentUser.email}</p>
      <p>{store.currentUserRole}</p>
    </span>
  </div>
}))

export default CurrentUser


// WEBPACK FOOTER //
// ./src/components/CurrentUser/index.js